export enum Platform {
  IOS = 'ios',
  TVOS = 'tvos',
  ANDROID = 'android',
  REACT_NATIVE = 'react-native',
  FLUTTER = 'flutter',
  BROWSER = 'browser',
  NODE = 'node',
  PYTHON = 'python',
}

export class PlatformUtil {
  static values() {
    return Object.values(Platform);
  }
  static fromString(platform: string) {
    switch (platform) {
      case Platform.ANDROID: return Platform.ANDROID;
      case Platform.IOS: return Platform.IOS;
      case Platform.REACT_NATIVE: return Platform.REACT_NATIVE;
      case Platform.FLUTTER: return Platform.FLUTTER;
      case Platform.BROWSER: return Platform.BROWSER;
      case Platform.NODE: return Platform.NODE;
      case Platform.PYTHON: return Platform.PYTHON;
      default: return Platform.ANDROID;
    }
  }
  // Server SDKs: a session is a request, and the server counts requests instead of storing a session for each.
  static isServer(platform?: Platform) {
    return platform === Platform.NODE || platform === Platform.PYTHON;
  }
}
